import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { withViewTransition } from '../utils/viewTransitionNavigate';
import './Navigation.css';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => location.pathname === path;

  const handleNav =
    (path) =>
    (e) => {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) {
        setIsMenuOpen(false);
        return;
      }
      e.preventDefault();
      setIsMenuOpen(false);
      if (location.pathname !== path) {
        withViewTransition(() => navigate(path));
      }
    };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link
          to="/"
          className="nav-logo"
          aria-label="Legit Smoke Shop home"
          onClick={handleNav('/')}
        >
          <img src="/LegitNoBack.png" alt="" className="nav-logo-img" />
          <span className="logo-text">Legit Smoke Shop</span>
        </Link>

        <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <Link
            to="/"
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
            onClick={handleNav('/')}
          >
            Home
          </Link>
          <Link
            to="/our-store"
            className={`nav-link ${isActive('/our-store') ? 'active' : ''}`}
            onClick={handleNav('/our-store')}
          >
            Our Store
          </Link>
          <Link
            to="/products"
            className={`nav-link ${isActive('/products') ? 'active' : ''}`}
            onClick={handleNav('/products')}
          >
            Products
          </Link>
          <Link
            to="/about"
            className={`nav-link ${isActive('/about') ? 'active' : ''}`}
            onClick={handleNav('/about')}
          >
            About Us
          </Link>
          <Link
            to="/contact"
            className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
            onClick={handleNav('/contact')}
          >
            Contact
          </Link>
        </div>

        <div
          className={`hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
